import logo from '../assets/nmslogo.jpeg';
import { COMPANY } from '../data';

const FOOTER_LINKS = [
  { title: 'Company',   links: [['Home','home'],['About','about'],['Blog','blog'],['Contact','contact'],['Privacy Policy','privacy']] },
  { title: 'Services',  links: [['Meta Ads','services'],['Google Ads','services'],['Social Media','services'],['Branding & Promotion','services']] },
  { title: 'Resources', links: [['Case Studies','portfolio'],['Pricing','pricing'],['Free Consultation','contact']] },
];

const SOCIAL_LINKS = [
  { label: 'Instagram', icon: '📸', href: COMPANY.social.instagram, color: '#E1306C' },
  { label: 'Facebook',  icon: '👥', href: COMPANY.social.facebook,  color: '#1877F2' },
  { label: 'LinkedIn',  icon: '💼', href: COMPANY.social.linkedin,  color: '#0A66C2' },
  { label: 'WhatsApp',  icon: '💬', href: COMPANY.social.whatsapp,  color: '#25D366' },
];

export default function Footer({ navigate }) {
  return (
    <footer style={{ borderTop: '1px solid rgba(255,255,255,0.08)', background: '#0a0d1a', paddingTop: 56 }}>
      <div className="container">

        {/* ── Top grid ── */}
        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', gap: 36, marginBottom: 48 }}>

          {/* Brand col */}
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
              <div style={{ width: 44, height: 44, borderRadius: 10, overflow: 'hidden', background: '#000', flexShrink: 0 }}>
                <img src={logo} alt="NMS" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              </div>
              <div>
                <div style={{ fontFamily: 'Georgia, serif', fontWeight: 700, fontSize: 15, lineHeight: 1.1, color: '#EEF0F8' }}>Neural Media</div>
                <div style={{ fontSize: 9, color: 'rgba(238,240,248,0.5)', letterSpacing: '0.12em', fontWeight: 700 }}>SOLUTIONS</div>
              </div>
            </div>
            <p style={{ color: 'rgba(238,240,248,0.5)', fontSize: 13, lineHeight: 1.75, maxWidth: 240, marginBottom: 20 }}>
              Your one stop marketing solution for real estate developers & channel partners across India.
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 7, marginBottom: 22 }}>
              <a href={COMPANY.whatsapp} style={{ color: 'rgba(238,240,248,0.55)', fontSize: 13, textDecoration: 'none' }}>📞 {COMPANY.phone}</a>
              <a href={`mailto:${COMPANY.email}`} style={{ color: 'rgba(238,240,248,0.55)', fontSize: 13, textDecoration: 'none' }}>✉️ {COMPANY.email}</a>
              <span style={{ color: 'rgba(238,240,248,0.55)', fontSize: 13 }}>📍 {COMPANY.address}</span>
            </div>
            {/* Social icons */}
            <div style={{ display: 'flex', gap: 10 }}>
              {SOCIAL_LINKS.map(s => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noreferrer"
                  title={s.label}
                  style={{
                    width: 36, height: 36,
                    background: 'rgba(255,255,255,0.05)',
                    border: '1px solid rgba(255,255,255,0.1)',
                    borderRadius: 9,
                    display: 'grid', placeItems: 'center',
                    fontSize: 16, textDecoration: 'none',
                    transition: 'all 0.2s',
                  }}
                  onMouseOver={e => { e.currentTarget.style.background = s.color + '22'; e.currentTarget.style.borderColor = s.color + '55'; }}
                  onMouseOut={e  => { e.currentTarget.style.background = 'rgba(255,255,255,0.05)'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.1)'; }}
                >
                  {s.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Nav cols */}
          {FOOTER_LINKS.map(col => (
            <div key={col.title}>
              <h4 style={{ fontWeight: 700, fontSize: 11, color: 'rgba(238,240,248,0.4)', letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: 18 }}>
                {col.title}
              </h4>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                {col.links.map(([label, page]) => (
                  <button
                    key={label}
                    onClick={() => navigate(page)}
                    style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'rgba(238,240,248,0.5)', textAlign: 'left', fontSize: 13, fontFamily: 'var(--fB)', padding: 0, transition: 'color 0.2s' }}
                    onMouseOver={e => e.currentTarget.style.color = '#00E5CC'}
                    onMouseOut={e  => e.currentTarget.style.color = 'rgba(238,240,248,0.5)'}
                  >
                    {label}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* ── Bottom bar ── */}
        <div style={{ borderTop: '1px solid rgba(255,255,255,0.07)', padding: '20px 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
          <p style={{ color: 'rgba(238,240,248,0.35)', fontSize: 12 }}>
            © 2025 Neural Media Solutions. All rights reserved. Ghaziabad, UP, India.
          </p>
          <div style={{ display: 'flex', gap: 20 }}>
            {[['Privacy Policy','privacy'],['Terms & Conditions','contact']].map(([l, page]) => (
              <button key={l} onClick={() => navigate(page)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'rgba(238,240,248,0.35)', fontSize: 12, fontFamily: 'var(--fB)', padding: 0 }}>{l}</button>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
